// extracted by mini-css-extract-plugin
export default {"body":"general_body__aiN9i"};